import { PopupTypes } from '@/features/Popup/types.ts';

export const defaultQueueState: { type: PopupTypes; popup: () => void }[] = [];

export type QueueSliceProps = {
  state: Partial<typeof defaultQueueState>;
  isPresenting: boolean;
  presentingType: PopupTypes | null;
  addToQueue: (newState: { type: PopupTypes; popup: () => void }) => void;
  removeFromQueue: () => void;
  removeFromQueueSpecific: (payload: { type: PopupTypes }) => void;
  resetQueueState: () => void;
  executeQueue: () => void;
};
